export default __webpack_public_path__ + "static/fort-anne-53d916fb1d0c19704d86552623047010.jpg";